import {
  Badge,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FilledInput,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Modal,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Cancel from "@mui/icons-material/Cancel";
import axios from "axios";
import { GoogleMap, useJsApiLoader, useGoogleMap } from "@react-google-maps/api";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FilterIcon from "@mui/icons-material/FilterAltOutlined";
import "react-datepicker/dist/react-datepicker.css";
import "react-dropdown/style.css";
import { baseUrl } from "../utils/constants";
import localizationStrings from "../utils/localizations";
import "./Tracking.css";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Chat from "./Chat";
import ChatIcon from "@mui/icons-material/Chat";
import { io } from "socket.io-client";
import PushToTalk from "../components/PushToTalk";
import { ChangeDestDialog } from "../components/ChangeDestinationModal";
import { useOutletContext } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";

const getBackgroundColor = (time) => {
  if (time >= 60 * 5) return "#7B0000";
  if (time >= 60 * 3) return "#E53935";
  if (time >= 60 * 2) return "#E65100";
  if (time >= 60 * 1) return "#1B5E20";
  return "#4CAF50";
};

const GMAP_LIBS = ["marker"];

// Custom AdvancedMarker component using AdvancedMarkerElement
function AdvancedMarker({ position, onClick, svgIcon, children }) {
  const map = useGoogleMap();
  const markerRef = useRef(null);

  useEffect(() => {
    if (!map || !position) return;
    try {
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        map,
        position,
      });
      if (!marker) {
        console.error("Failed to create marker");
        return;
      }

      if (svgIcon) {
        const div = document.createElement("div");
        div.innerHTML = svgIcon;
        div.style.cursor = "pointer";
        marker.content = div;
      }

      if (onClick) {
        marker.addListener("click", onClick);
      }

      markerRef.current = marker;

      return () => {
        marker.map = null;
      };
    } catch (e) {
      console.error("Error creating marker:", e);
      return null;
    }
  }, [map, position?.lat, position?.lng, svgIcon, onClick]);

  return null;
}

const otherWisePath = (fill) =>
  '<path d="M17.5122 9.13218C17.0998 9.30138 16.7826 9.6292 16.6715 10.0046C16.6028 10.232 16.5869 10.5651 16.5869 11.7071V13.1241H15.926C15.1382 13.1241 14.9796 13.177 14.9003 13.4837C14.8685 13.5894 14.8421 13.7533 14.8421 13.8485C14.8421 13.9913 14.8209 14.0177 14.6729 14.0494C14.3927 14.1129 14.2235 14.2186 14.1019 14.4195C13.9961 14.5887 13.9908 14.6575 14.0067 15.4241L14.0226 16.2437L14.2235 16.4393L14.4191 16.6402L14.9901 16.6561C15.6616 16.6772 15.889 16.6085 16.0582 16.3389C16.1586 16.1802 16.1639 16.0956 16.1534 15.3078L16.1375 14.4513L15.9842 14.2926C15.8996 14.208 15.7568 14.1182 15.6669 14.1023C15.3338 14.0336 15.318 14.023 15.318 13.8379C15.318 13.5894 15.4237 13.5471 16.0529 13.5471H16.5869V20.7115C16.5869 25.6975 16.6028 27.9552 16.6451 28.1508C16.7508 28.6743 17.0311 29.1607 17.4065 29.4991L17.7501 29.8057V30.4138C17.7501 31.1329 17.803 31.3549 18.0304 31.614C18.3265 31.9524 18.5009 32 19.5214 32C20.5419 32 20.7163 31.9524 21.0124 31.614C21.2292 31.3655 21.2927 31.1329 21.2927 30.5777V30.1336L24.7929 30.1653C26.7175 30.1864 28.8324 30.2023 29.4986 30.2023H30.7042V30.6729C30.7042 31.0853 30.72 31.1752 30.8522 31.4237C30.9685 31.651 31.0531 31.7356 31.2805 31.852C31.5554 31.9947 31.5766 32 32.4754 32C33.3743 32 33.3954 31.9947 33.6704 31.852C33.8977 31.7356 33.9823 31.651 34.0986 31.4237C34.2414 31.154 34.2467 31.1064 34.2467 30.4032V29.663L34.4952 29.388C34.6274 29.24 34.823 28.9386 34.9288 28.7218L35.1191 28.3253L35.1455 25.9195L35.172 23.5138L36.0232 23.4874C36.6313 23.4662 36.9009 23.4398 36.9591 23.3869C37.0596 23.3076 37.1547 23.0062 37.1547 22.7683C37.1547 22.6149 37.1706 22.5991 37.3557 22.5674C37.472 22.5515 37.6253 22.488 37.7046 22.4246C37.9849 22.2078 38.0007 22.1074 38.0007 20.8595C38.0007 19.5906 37.9849 19.5271 37.6518 19.3051C37.4244 19.157 36.4092 19.157 36.166 19.3103C35.8541 19.5007 35.8329 19.5959 35.8329 20.9283V22.1232L36.0338 22.3294C36.1819 22.4722 36.3035 22.5409 36.4568 22.5674C36.663 22.5991 36.6789 22.6149 36.6789 22.7683C36.6789 23.0432 36.6154 23.0644 35.8805 23.0644C35.32 23.0644 35.2037 23.0485 35.1773 22.9798C35.1614 22.9322 35.1455 20.0136 35.1455 16.4922V10.0839L35.0187 9.81425C34.8706 9.49172 34.6009 9.25908 34.2097 9.11103C33.9189 9 33.9189 9 25.8768 9H17.8295L17.5122 9.13218ZM29.4246 10.0363C29.5357 10.1103 29.5409 10.1368 29.5409 10.951C29.5409 11.6807 29.5304 11.797 29.4511 11.871C29.3665 11.9398 28.9435 11.9556 25.8768 11.9715L22.3924 11.9874L22.292 11.8605C22.2021 11.7547 22.1915 11.649 22.1915 10.9828C22.1915 10.5651 22.2074 10.1844 22.2232 10.1368C22.3184 9.89885 22.3872 9.89356 25.9455 9.93057C28.7214 9.95701 29.3242 9.97287 29.4246 10.0363ZM33.6122 13.0184C33.718 13.1241 33.718 13.1929 33.718 18.5331C33.718 23.1225 33.7074 23.9579 33.6439 24.0478C33.5699 24.1483 33.4219 24.1483 25.9297 24.1641L18.2895 24.1747L18.1784 24.0372C18.0674 23.8945 18.0674 23.8839 18.0674 18.5437C18.0674 13.2087 18.0674 13.1929 18.1784 13.0501L18.2842 12.9126H25.898C33.4377 12.9126 33.5065 12.9126 33.6122 13.0184ZM19.0826 26.9241C19.2253 27.0722 19.2412 27.1145 19.2147 27.3101C19.1777 27.5745 18.9821 27.7701 18.7495 27.7701C18.3423 27.7701 18.0938 27.4264 18.2472 27.0669C18.337 26.8395 18.4534 26.7708 18.7177 26.7655C18.8763 26.7655 18.9557 26.8025 19.0826 26.9241ZM20.5789 26.8977C20.6793 26.9929 20.7111 27.0828 20.7111 27.2625C20.7111 27.4582 20.6846 27.5163 20.5472 27.6326C20.3198 27.823 20.066 27.8177 19.8598 27.6168C19.6589 27.4106 19.6483 27.1092 19.8386 26.903C20.0184 26.7126 20.3938 26.7074 20.5789 26.8977ZM32.0895 26.8237C32.1476 26.8554 32.2269 26.9611 32.2692 27.0669C32.412 27.4053 32.1793 27.7701 31.8145 27.7701C31.3492 27.7701 31.1219 27.1515 31.4814 26.8713C31.6295 26.7549 31.9203 26.7338 32.0895 26.8237ZM33.6704 26.9189C33.866 27.1198 33.8766 27.3841 33.6968 27.5956C33.5911 27.7172 33.5276 27.7437 33.3214 27.7437C33.1152 27.7437 33.0518 27.7172 32.946 27.5956C32.8085 27.4317 32.7768 27.1145 32.8878 26.9717C33.0835 26.7179 33.443 26.6968 33.6704 26.9189Z" fill="' +
  fill +
  '" />';
function reverseNumbers(string) {
  var regex = /\d+(?:\.\d+)?/g;
  var matches = string.match(regex);
  var res = string;
  for (var i = 0; i < matches.length; i++) {
    res = res.replace(matches[i], matches[i].split("").reverse().join(""));
  }
  return res;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}
String.prototype.EntoAr = function () {
  return this.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};
function Tracking(props) {
  const [startDate, setStartDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [mapData, setMapData] = useState([]);
  const [selected, setSelected] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible1, setModalVisible1] = useState(false);
  const handle = useFullScreenHandle();
  const [fullScreen, setFullScreen] = useState(false);
  const [polyLineData, setPolyLineData] = useState([]);
  const [chatVisible, setChatVisible] = useState(false);
  const [currentSelectedGuidanceId, setCurrentSelectedGuidanceId] = useState(null);
  const [currentSelectedChatTitle, setCurrentSelectedChatTitle] = useState(null);
  const [allEst, setAllEst] = useState([]);
  const { reload } = useOutletContext();

  const [filterShown, setFilterShown] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({
    time: 0,
    needHelp: 0,
    chat_unread: 0,
    type: [],
    by_est: [],
    destination: 0,
  });
  const filters = useMemo(
    () => ({
      time: {
        type: "radio",
        title: localizationStrings.DelayedTrips,
        options: [
          { value: 0, label: localizationStrings.All },
          { value: 1, label: localizationStrings.delay_1Hr },
          { value: 2, label: localizationStrings.delay_2Hr },
          { value: 3, label: localizationStrings.delay_3Hr },
          { value: 5, label: localizationStrings.delay_5Hr },
        ],
        filterFunction: (item, value) => {
          if (value == 0) return true;
          return item.EndDatetime
            ? item.PickupTime
              ? Math.abs(item.assemblyPointTime) >= 60 * value
              : Math.abs(item.pickupTime) >= 60 * value
            : Math.abs(item.bussTime) >= 60 * value;
        },
      },
      type: {
        type: "checkbox",
        title: localizationStrings.Type,
        options: [
          { value: "trip", label: localizationStrings.Trip },
          { value: "pickup", label: localizationStrings.Pickup },
          { value: "assemblyPoint", label: localizationStrings.AssemblyPoint },
        ],
        filterFunction: (item, value) => {
          if (value.length == 0) return true;
          return value.includes(!item.EndDatetime ? "trip" : !item.PickupTime ? "pickup" : "assemblyPoint");
        },
      },
      by_est: {
        type: "by_est",
        filterFunction: (item, value) => {
          if (value.length == 0) return true;
          return value.some((est) => item.Est_ID?.includes(est));
        },
      },

      needHelp: {
        type: "radio",
        title: localizationStrings.NeedsHelp,
        options: [
          { value: 0, label: localizationStrings.All },
          { value: 1, label: localizationStrings.Yes },
          { value: 2, label: localizationStrings.No },
        ],
        filterFunction: (item, value) => {
          // console.log(item.NeedHelp, value);
          if (value == 0) return true;
          return value == 1 ? !!item.NeedHelp : !item.NeedHelp;
        },
      },
      chat_unread: {
        type: "radio",
        title: localizationStrings.UnreadMessages,
        options: [
          { value: 0, label: localizationStrings.All },
          { value: 1, label: localizationStrings.Yes },
          { value: 2, label: localizationStrings.No },
        ],
        filterFunction: (item, value) => {
          if (value == 0) return true;
          return value == 1 ? !!item.unreadCount : !item.unreadCount;
        },
      },
      destination: {
        type: "radio",
        title: localizationStrings.DestinationCount,
        options: [
          { value: 0, label: localizationStrings.All },
          { value: 1, label: localizationStrings.SingleDestination },
          { value: 2, label: localizationStrings.MultipleDestinations },
        ],
        filterFunction: (item, value) => {
          if (value == 0) return true;
          return value == 1 ? item.destination_count == 1 : item.destination_count > 1;
        },
      },
    }),
    [reload],
  );

  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const [currentSelectedConfirmDialog, setCurrentSelectedConfirmDialog] = useState(null);

  const handleOpenConfirmDialog = (currentSelected) => {
    setCurrentSelectedConfirmDialog(currentSelected);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = (didPressYes) => {
    if (didPressYes) {
      finishTripButton(currentSelectedConfirmDialog);
    }
    setOpenConfirmDialog(false);
  };
  useEffect(() => {
    if (fullScreen) {
      setTimeout(() => setFullScreen(false), 100);
    }

    return () => {};
  }, [fullScreen]);

  const handleOpen = (item) => {
    setSelected(item[0]?.LeavingNo || item?.LeavingNo || null);
    setModalVisible(true);
  };
  const handleClose = () => {
    setSelected(null);
    setModalVisible(false);
  };
  const handleOpen1 = (item) => {
    setSelected(item[0]?.LeavingNo || item?.LeavingNo || null);
    setModalVisible1(true);
  };
  const handleClose1 = () => {
    setSelected(null);
    setModalVisible1(false);
  };

  const getPolyLineData = (data) => {
    var newData = {};
    for (let i = 0; i < data.length; i++) {
      const elem = data[i];
      if (!newData[elem.LeavingNo]) {
        newData[elem.LeavingNo] = [];
      }
      newData[elem.LeavingNo].push(elem);
    }
    // console.log(newData);
    return Object.values(newData).map((v) => {
      let item = null;
      let currentDestination = 0;
      let destinations = {};
      ["EndDatetime", "PickupTime", "AssemblyPointTime"].forEach((key) => {
        for (let i = 0; i < v.length; i++) {
          destinations[v[i]?.HouseID] = {
            name: v[i]?.HouseName,
            lat: v[i]?.Latitude,
            lng: v[i]?.Longitude,
            hajj_count: v[i]?.hajj_count,
            ended_at: v[i]?.EndDatetime,
            hid: v[i]?.hid,
            Est_Name: v[i]?.Est_Name,
          };
        }
        if (item) return;
        for (let i = 0; i < v.length; i++) {
          // if (v[0]?.LeavingNo == "97966") {
          //   console.log(v[i], key, v[i]["StartDatetime"]);
          // }
          if (!v[i]["StartDatetime"]) {
            if (!item) {
              currentDestination--;
            }
            continue;
          }
          if (!v[i][key]) {
            item = v[i];
            currentDestination += i;
            continue;
          } else {
            if (item) {
              currentDestination++;
              continue;
            }
          }
        }
      });
      // if (v[0]?.LeavingNo == "100891" || v[0]?.LeavingNo == "101313") {
      //   console.log(
      //     v,
      //     item,
      //     moment(new Date(item.StartDatetime))
      //       .utc()
      //       .diff(item.EndDatetime ? moment(new Date(item.EndDatetime)) : moment(), "minute") -
      //       (item.EndDatetime ? 0 : 180),
      //   );
      // }
      // console.log(item);
      return [
        {
          ...item,
          // destination_count: v.length,
          currentDestination: currentDestination + 1,
          destinations: Object.values(destinations).sort(
            (a, b) => new Date(b.ended_at || 0) - new Date(a.ended_at || 0),
          ),
          bussTime:
            (item.EndDatetime ? moment(moment(new Date(item.EndDatetime))).utc() : moment()).diff(
              new Date(item.StartDatetime),
              "minute",
            ) + (item.EndDatetime ? 0 : 180),
          pickupTime:
            (item.PickupTime ? moment(new Date(item.PickupTime)).utc() : moment()).diff(
              item.EndDatetime ? moment(new Date(item.EndDatetime)) : moment(),
              "minute",
            ) + (item.PickupTime ? 0 : item.EndDatetime ? 180 : 0),
          assemblyPointTime:
            (item.AssemblyPointTime ? moment(new Date(item.AssemblyPointTime)).utc() : moment()).diff(
              item.PickupTime ? moment(new Date(item.PickupTime)) : moment(),
              "minute",
            ) + (item.AssemblyPointTime ? 0 : item.PickupTime ? 180 : 0),
        },
      ];
    });
  };

  const getData = (data) => {
    var Est_ID = {};
    var Est_Name = {};
    var HEB_No = {};
    var HEB_Name = {};
    var unread = {};
    for (let i = 0; i < data[1].length; i++) {
      const elem = data[1][i];
      unread[elem.Guidance_ID] = elem.count;
    }
    for (let i = 0; i < data[2].length; i++) {
      const elem = data[2][i];
      if (!Est_ID[elem.parent_house_id]) {
        Est_ID[elem.parent_house_id] = [elem.EST_ID];
        Est_Name[elem.parent_house_id] = [elem.EST_Name];
      } else {
        Est_ID[elem.parent_house_id].push(elem.EST_ID);
        Est_Name[elem.parent_house_id].push(elem.EST_Name);
      }
    }
    for (let i = 0; i < data[3].length; i++) {
      const elem = data[3][i];
      if (!HEB_No[elem.parent_house_id]) {
        HEB_No[elem.parent_house_id] = [elem.HEB_No];
        HEB_Name[elem.parent_house_id] = [elem.Heb_Name];
      } else {
        HEB_No[elem.parent_house_id].push(elem.HEB_No);
        HEB_Name[elem.parent_house_id].push(elem.Heb_Name);
      }
    }
    for (let i = 0; i < data[0].length; i++) {
      const elem = data[0][i];
      data[0][i].Est_ID = Est_ID[elem.hid]?.join(",") ?? "";
      data[0][i].Est_Name = Est_Name[elem.hid]?.join(",") ?? "";
      data[0][i].HEB_No = HEB_No[elem.hid]?.join(",") ?? "";
      data[0][i].HEB_Name = HEB_Name[elem.hid]?.join(",") ?? "";
      data[0][i].unreadCount = unread[elem.Employee_No];
    }
    return data[0];
  };

  const getTracking = async (silent = false) => {
    try {
      if (!silent) setLoading(true);
      const data = await axios.get(baseUrl + "getLocTrack");

      //alert(baseUrl + 'getLocTrack?date=' + encodeURIComponent(startDate.toISOString()));

      //https://mobapp.arshdni.app/api/admin/getLocTrack?date=2023-06-08T07%3A09%3A05.911Z

      if (data.data.status) {
        const mData = getData([data.data.result || [], data.data.unread, data.data.ests, data.data.heb]);
        let polyLine = getPolyLineData(mData);
        setPolyLineData(polyLine);
        setMapData(mData);
        const ests = [];
        mData.map((v) => {
          const Est_Name = (v.Est_Name || "").split(",");
          (v.Est_ID || "").split(",").map((r, i) => {
            if (r && !ests.find((s) => s.Est_ID == r)) {
              ests.push({ Est_ID: r, Est_Name: Est_Name[i], count: 1 });
            } else if (r) {
              const estIndex = ests.findIndex((s) => s.Est_ID == r);
              ests[estIndex].count += 1;
            }
          });
        });
        setAllEst(ests);
        // if (selected) {
        //   setSelected(polyLine.find((v) => v[0].id == (selected[0].id || selected.id)) || null);
        // }
      } else {
        alert(data.data.message || "An Error occured");
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      // alert(e.message);
      console.warn(e);
    }
  };
  useEffect(() => {
    getTracking();
    const int = setInterval(() => {
      getTracking(true);
    }, 15000);
    return () => clearInterval(int);
  }, []);

  // useEffect(() => {
  //   if (!selected) {
  //     setSelected(polyLineData[0]);
  //   }
  // }, [selected, polyLineData]);

  function secondsToDhms(seconds) {
    seconds = Number(seconds);
    seconds = Math.abs(seconds);
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);

    var hDisplay = h > 0 ? h + `${localizationStrings.hrs} ` : "";
    var mDisplay = m > 0 ? m + `${localizationStrings.min} ` : "";
    return ((hDisplay + mDisplay).trim() || `0${localizationStrings.min}`).toLocaleLowerCase();
  }

  const formatTime = (mins) => {
    return secondsToDhms(mins * 60);
  };
  const dataToShow = useMemo(() => {
    const stats = {
      trips: { total: 0, filtered: 0, averageTime: 0 },
      pickups: { total: 0, filtered: 0, averageTime: 0 },
      assemblyPoints: { total: 0, filtered: 0, averageTime: 0 },
    };
    const filteredPolyLine = polyLineData
      .filter((v) => {
        if (v[0].PickupTime) {
          stats.assemblyPoints.total += 1;
          stats.assemblyPoints.averageTime += v[0].assemblyPointTime;
        } else if (v[0].EndDatetime) {
          stats.pickups.total += 1;
          stats.pickups.averageTime += v[0].pickupTime;
        } else {
          stats.trips.total += 1;
          stats.trips.averageTime += v[0].bussTime;
        }

        for (let key in selectedFilters) {
          const filter = filters[key];
          const filterValue = selectedFilters[key];
          if (filterValue && filterValue !== 0) {
            if (!filter.filterFunction(v[0], filterValue)) {
              return false;
            }
          }
        }
        if (search) {
          const searchIn = [
            v[0].Employee_No,
            v[0].Guidance_ID,
            v[0].HouseName,
            v[0].Full_Name,
            v[0].ID_No,
            v[0].Mobile_No,
            v[0].biOperatingCardNo,
            v[0].pathName,
            v[0].LeavingNo,
            v[0].Est_Name,
            v[0].EST_ID,
            v[0].BusNo,
            v[0].BusPlant,
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();
          if (!searchIn.includes(search.toLowerCase())) {
            return false;
          }
        }
        if (v[0].PickupTime) stats.assemblyPoints.filtered += 1;
        else if (v[0].EndDatetime) stats.pickups.filtered += 1;
        else stats.trips.filtered += 1;
        return true;
      })
      .sort((b, a) => {
        // Priority 1 (lowest): Sort by StartDatetime ascending
        const byStartDatetime = (() => {
          if (a[0].StartDatetime && b[0].StartDatetime)
            return new Date(a[0].StartDatetime) - new Date(b[0].StartDatetime);
          if (a[0].StartDatetime) return -1;
          if (b[0].StartDatetime) return 1;
          return 0;
        })();

        // // Priority 2: Items with unreadCount come first
        // const byUnreadCount = (() => {
        //   if (a[0].unreadCount && b[0].unreadCount) return 0;
        //   if (a[0].unreadCount) return -1;
        //   if (b[0].unreadCount) return 1;
        //   return 0;
        // })();

        // // Priority 3: Items with datetime come first
        // const byDatetime = (() => {
        //   if (a[0].datetime && b[0].datetime) return 0;
        //   if (a[0].datetime) return -1;
        //   if (b[0].datetime) return 1;
        //   return 0;
        // })();

        // // Priority 4: Offline buses come first
        // const byOffline = (() => {
        //   const isOffline = (item) => {
        //     const diffMins = Math.abs(
        //       moment(item.datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute"),
        //     );
        //     const offline = diffMins > 5 && !item.EndDatetime;
        //     if (
        //       offline &&
        //       diffMins > Math.abs(item.bussTime) + Math.abs(item.pickupTime) + Math.abs(item.assemblyPointTime)
        //     ) {
        //       return false;
        //     }
        //     return offline;
        //   };

        //   const offlineA = isOffline(a[0]);
        //   const offlineB = isOffline(b[0]);
        //   if (offlineA && offlineB) return 0;
        //   if (offlineA) return -1;
        //   if (offlineB) return 1;
        //   return 0;
        // })();

        // // Priority 5 (highest): Items needing help come first
        // const byNeedHelp = (() => {
        //   if (a[0].NeedHelp && b[0].NeedHelp) return 0;
        //   if (a[0].NeedHelp) return -1;
        //   if (b[0].NeedHelp) return 1;
        //   return 0;
        // })();

        // if (a[0].LeavingNo == "97966" || b[0].LeavingNo == "97966") {
        //   console.log(a[0].LeavingNo, b[0].LeavingNo, {
        //     byStartDatetime,
        //     byUnreadCount,
        //     byDatetime,
        //     byOffline,
        //     byNeedHelp,
        //   });
        // }

        // Return the first non-zero result in priority order (highest priority first)
        // return byNeedHelp || byOffline || byDatetime || byUnreadCount || byStartDatetime;
        return byStartDatetime;
      });

    // .sort((a, b) =>
    //   a.StartDatetime && b.StartDatetime
    //     ? new Date(a.StartDatetime) - new Date(b.StartDatetime)
    //     : a.StartDatetime
    //       ? -1
    //       : b.StartDatetime
    //         ? 1
    //         : 0,
    // )
    // .sort((a, b) => (a[0].unreadCount && b[0].unreadCount ? 0 : a[0].unreadCount ? -1 : b[0].unreadCount ? 1 : 0))
    // .sort((a, b) => (a[0].datetime && b[0].datetime ? 0 : a[0].datetime ? -1 : b[0].datetime ? 1 : 0))
    // .sort((a, b) => {
    //   let offlineFora =
    //     Math.abs(moment(a[0].datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute")) > 5 && !a[0].EndDatetime;
    //   if (
    //     offlineFora &&
    //     Math.abs(moment(a[0].datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute")) >
    //       Math.abs(a[0].bussTime) + Math.abs(a[0].pickupTime) + Math.abs(a[0].assemblyPointTime)
    //   ) {
    //     offlineFora = false;
    //   }
    //   let offlineForb =
    //     Math.abs(moment(b[0].datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute")) > 5 && !b[0].EndDatetime;
    //   if (
    //     offlineForb &&
    //     Math.abs(moment(b[0].datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute")) >
    //       Math.abs(b[0].bussTime) + Math.abs(b[0].pickupTime) + Math.abs(b[0].assemblyPointTime)
    //   ) {
    //     offlineForb = false;
    //   }
    //   return offlineFora && offlineForb ? 0 : offlineFora ? -1 : offlineForb ? 1 : 0;
    // })
    // .sort((a, b) => (a[0].NeedHelp && b[0].NeedHelp ? 0 : a[0].NeedHelp ? -1 : b[0].NeedHelp ? 1 : 0));

    stats.trips.averageTime = stats.trips.total ? stats.trips.averageTime / stats.trips.total : 0;
    stats.pickups.averageTime = stats.pickups.total ? stats.pickups.averageTime / stats.pickups.total : 0;
    stats.assemblyPoints.averageTime = stats.assemblyPoints.total
      ? stats.assemblyPoints.averageTime / stats.assemblyPoints.total
      : 0;
    // .filter((v) => {
    //   switch (selectedFilter) {
    //     case 1:
    //       return v[0].NeedHelp == 1;
    //     case 2:
    //       return (
    //         Math.abs(
    //           moment(v[0].datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute", true),
    //         ) > 3 && !v[0]?.EndDatetime
    //       );
    //     case 3:
    //       return v[0]?.EndDatetime
    //         ? Math.abs(v[0].pickupTime) >= 60 && Math.abs(v[0].pickupTime) < 120
    //         : Math.abs(v[0].bussTime) >= 60 && Math.abs(v[0].bussTime) < 120;

    //     case 4:
    //       return v[0]?.EndDatetime ? Math.abs(v[0].pickupTime) >= 120 : Math.abs(v[0].bussTime) >= 120;
    //     // case 3:
    //     //   return Math.abs(moment(v[0].datetime).add(1, 'hour').diff(moment(), 'minute', true)) > 3 && !v[0]?.EndDatetime;

    //     // case 4:
    //     //   return v[0].bussTime < 60 ? false : v[0].bussTime >= 60 && v[0].bussTime < 120 ? false : true;
    //     case 5:
    //       return !!v[0].EndDatetime;
    //     default:
    //       return true;
    //   }
    // })
    // .filter((v) => {
    //   if (selectedEst.length == 0) {
    //     return true;
    //   }
    //   if (selectedEst.find((r) => (v[0].Est_ID || "").split(",").includes(r))) {
    //     return true;
    //   }
    //   return false;
    // });
    return { filteredPolyLine, stats };
  }, [polyLineData, selectedFilters, filters, search]);
  const currentSelected = useMemo(() => {
    if (!selected) return null;
    const out = polyLineData.find((item) => item[0]?.LeavingNo == selected);
    return out[0] || null;
  }, [selected, polyLineData]);

  const pressResolve = async (silent = false) => {
    try {
      handleClose1();
      if (!silent) setLoading(true);
      const data = await axios.post(baseUrl + "resolveNeedHelp", {
        houseID: currentSelected.id,
      });
      if (data.data.status) {
        await getTracking(true);
      } else {
        alert(data.data.message || "An Error occured");
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      // alert(e.message);
      console.warn(e);
    }
  };

  // if (loading) {
  //   return (
  //     <div className='tracking-container' style={{ alignItems: 'center', justifyContent: 'center' }}>
  //       <div className='loader'></div>
  //     </div>
  //   );
  // }
  // if (mapData.length === 0) {
  //   return (
  //     <div className='tracking-container' style={{ alignItems: 'center', justifyContent: 'center' }}>
  //       <h3 style={{ textAlign: 'center' }}>{localizationStrings.NoActiveTrips}</h3>
  //     </div>
  //   );
  // }
  const checkRoleExists = (role_id) => {
    return ((JSON.parse(localStorage.getItem("user") || "{}") || {}).roles || []).indexOf(role_id) > -1;
  };

  const finishTripButton = async (currentSelected, silent = false) => {
    try {
      handleClose();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (!silent) setLoading(true);
      if (!currentSelected.EndDatetime) {
        const pi =
          dataToShow.filteredPolyLine.find((v) => v[0].Employee_No === currentSelected.Employee_No)?.at(-1) || {};
        const data = await axios.get(
          baseUrl +
            "endTrip/" +
            currentSelected.id +
            "?lat=" +
            0 +
            "&lng=" +
            0 +
            "&from_admin=1&login_id=" +
            JSON.parse(localStorage.getItem("user") || "{}").login_id,
        );

        if (data.data.status) {
          await getTracking(true);
        } else {
          alert(data.data.message || "An Error occured");
        }
      } else if (!currentSelected.PickupTime) {
        const data = await axios.get(
          baseUrl +
            "confirmPickup/" +
            currentSelected.id +
            "?from_admin=1&login_id=" +
            JSON.parse(localStorage.getItem("user") || "{}").login_id,
        );
        if (data.data.status) {
          await getTracking(true);
        } else {
          alert(data.data.message || "An Error occured");
        }
      } else if (!currentSelected.AssemblyPointTime) {
        const data = await axios.get(
          baseUrl +
            "confirmAssemblyPoint/" +
            currentSelected.trip_id +
            "?from_admin=1&login_id=" +
            JSON.parse(localStorage.getItem("user") || "{}").login_id,
        );
        if (data.data.status) {
          await getTracking(true);
        } else {
          alert(data.data.message || "An Error occured");
        }
      } else {
        window.location.reload();
      }

      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      // alert(e.message);
      console.warn(e);
    }
  };

  const chat = async (currentSelected) => {
    setCurrentSelectedGuidanceId(currentSelected.Guidance_ID);
    setCurrentSelectedChatTitle(localizationStrings.ChatWithX.replace("x", currentSelected.Full_Name));
    setChatVisible(true);
  };

  const { isLoaded: mapsLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBNZKUOIDDz0KZ3jColelJGpWm1gAJPcfg",
    libraries: GMAP_LIBS,
    mapIds: ["DEMO_MAP_ID"],
  });

  const [mapCenter, setMapCenter] = useState({ lat: 21.3891, lng: 39.8579 });
  useEffect(() => {
    if (mapCenter.lat === 21.3891 && mapCenter.lng === 39.8579 && mapData.length > 0) {
      // get the center of all points
      const lat = mapData.reduce((sum, v) => sum + parseFloat(v.latitude) || 0, 0) / mapData.length;
      const lng = mapData.reduce((sum, v) => sum + parseFloat(v.longitude) || 0, 0) / mapData.length;
      setMapCenter({ lat: lat, lng: lng });
    }
  }, [mapData, mapCenter]);

  return (
    <div className="tracking-container">
      <div
        style={{
          flex: 1,
          width: "20%",
          display: "flex",
          alignItems: "stretch",
          flexDirection: "column",
        }}
      >
        <List sx={{ alignItems: "stretch", overflowY: "scroll" }}>
          <React.Fragment>
            <ListItem>
              <ListItemText>
                <Typography sx={{ fontSize: 16, fontWeight: "700", textAlign: "center" }}>
                  {localizationStrings.TotalTrips} ({dataToShow.stats.trips.filtered}
                  {dataToShow.stats.trips.total == dataToShow.stats.trips.filtered
                    ? ""
                    : " / " + dataToShow.stats.trips.total}
                  ) {dataToShow.stats.trips.averageTime ? " - " + formatTime(dataToShow.stats.trips.averageTime) : ""}
                </Typography>
                <Typography sx={{ fontSize: 16, fontWeight: "700", textAlign: "center" }}>
                  {localizationStrings.TotalPickups} ({dataToShow.stats.pickups.filtered}
                  {dataToShow.stats.pickups.total == dataToShow.stats.pickups.filtered
                    ? ""
                    : " / " + dataToShow.stats.pickups.total}
                  ){" "}
                  {dataToShow.stats.pickups.averageTime ? " - " + formatTime(dataToShow.stats.pickups.averageTime) : ""}
                </Typography>
                <Typography sx={{ fontSize: 16, fontWeight: "700", textAlign: "center" }}>
                  {localizationStrings.TotalAssemblyPointPickups} ({dataToShow.stats.assemblyPoints.filtered}
                  {dataToShow.stats.assemblyPoints.total == dataToShow.stats.assemblyPoints.filtered
                    ? ""
                    : " / " + dataToShow.stats.assemblyPoints.total}
                  ){" "}
                  {dataToShow.stats.assemblyPoints.averageTime
                    ? " - " + formatTime(dataToShow.stats.assemblyPoints.averageTime)
                    : ""}
                </Typography>
              </ListItemText>
            </ListItem>
            {/* Search Input */}
            <Box sx={{ my: 1, mx: 2 }}>
              <FormControl fullWidth variant="filled">
                <InputLabel htmlFor="search-input">{localizationStrings.Search}</InputLabel>
                <FilledInput
                  id="search-input"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  label={localizationStrings.Search}
                />
              </FormControl>
            </Box>

            <Box style={{ position: "absolute", top: 20, right: 20 }} onClick={() => setFilterShown(true)}>
              <FilterIcon style={{ fontSize: 30 }} />
            </Box>
          </React.Fragment>
          {/* <Box
            sx={{
              marginBottom: "10px",
              paddingBottom: "10px",
              paddingRight: "15px",
              paddingLeft: "15px",
            }}
          >
            <FormControl fullWidth variant="filled">
              <InputLabel id="demo-simple-select-label">{localizationStrings.Company}</InputLabel>
              <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={selectedEst}
                onChange={(e) =>
                  setSelectedEst(
                    typeof e.target.value == "string" ? e.target.value.split(",").map(parseInt) : e.target.value,
                  )
                }
                // onChange={(e) => { }}
                input={<FilledInput id="select-multiple-chip" label="Chip" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => {
                      return <Chip key={value} label={value} />;
                    })}
                  </Box>
                )}
              >
                {allEst.map((val) => (
                  <MenuItem key={val.Est_ID} value={val.Est_ID} title={val.Est_Name}>
                    <Checkbox checked={selectedEst.indexOf(val.Est_ID) > -1} />
                    <ListItemText
                      primaryTypographyProps={{
                        fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
                      }}
                      primary={"(" + val.Est_ID + ")" + val.Est_Name}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box> */}
          {/* <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              overflowX: "scroll",
              width: 500,
              scrollbarGutter: "stable",
              marginBottom: "10px",
              paddingBottom: "10px",
              paddingRight: "10px",
            }}
            className="small-scroll"
          >
            <Chip
              clickable
              onClick={() => setSelectedFilter(selectedFilter == 1 ? null : 1)}
              color={selectedFilter == 1 ? "primary" : "default"}
              label={localizationStrings.requestForHelp}
              onDelete={selectedFilter != 1 ? null : () => setSelectedFilter(null)}
              deleteIcon={<Cancel color="#000" />}
              style={{ marginLeft: "15px", color: "black" }}
            />
            <Chip
              clickable
              onClick={() => setSelectedFilter(selectedFilter == 2 ? null : 2)}
              color={selectedFilter == 2 ? "primary" : "default"}
              label={localizationStrings.offlineGuidance}
              onDelete={selectedFilter != 2 ? null : () => setSelectedFilter(null)}
              deleteIcon={<Cancel color="#000" />}
              style={{ marginLeft: "15px", color: "black" }}
            />
            <Chip
              clickable
              onClick={() => setSelectedFilter(selectedFilter == 3 ? null : 3)}
              color={selectedFilter == 3 ? "primary" : "default"}
              label={localizationStrings.delay_1Hr}
              onDelete={selectedFilter != 3 ? null : () => setSelectedFilter(null)}
              deleteIcon={<Cancel color="#000" />}
              style={{ marginLeft: "15px", color: "black" }}
            />
            <Chip
              clickable
              onClick={() => setSelectedFilter(selectedFilter == 4 ? null : 4)}
              color={selectedFilter == 4 ? "primary" : "default"}
              label={localizationStrings.delay_2Hr}
              onDelete={selectedFilter != 4 ? null : () => setSelectedFilter(null)}
              deleteIcon={<Cancel color="#000" />}
              style={{ marginLeft: "15px", color: "black" }}
            />
            <Chip
              clickable
              onClick={() => setSelectedFilter(selectedFilter == 5 ? null : 5)}
              color={selectedFilter == 5 ? "primary" : "default"}
              label={localizationStrings.WaitingForPickup}
              onDelete={selectedFilter != 5 ? null : () => setSelectedFilter(null)}
              deleteIcon={<Cancel color="#000" />}
              style={{ marginLeft: "15px", color: "black" }}
            />
          </Box> */}
          {dataToShow.filteredPolyLine.map((v) => (
            <EmployeeItem
              {...v[0]}
              allData={v}
              handleOpen={handleOpen}
              formatTime={formatTime}
              handleOpen1={handleOpen1}
              chat={chat}
            />
          ))}
        </List>
      </div>
      <FullScreen handle={handle}>
        {!fullScreen && (
          <div className={"mapctr"} id="mapctr">
            {loading ? (
              <h3>{localizationStrings.Loading}...</h3>
            ) : !mapsLoaded ? (
              <h3>{localizationStrings.Loading} Google Maps...</h3>
            ) : (
              // REPLACED Map (google-maps-react) with GoogleMap
              <GoogleMap
                mapContainerClassName={handle.active ? "fullscreenMap" : "mapcontainer"}
                center={mapCenter}
                zoom={11}
                options={{ fullscreenControl: false, mapId: "DEMO_MAP_ID" }}
              >
                <button className="fullscreenButton" onClick={() => (handle.active ? handle.exit() : handle.enter())}>
                  <img
                    style={{ height: 18, width: 18 }}
                    alt=""
                    src={
                      handle.active
                        ? "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M4%204H0v2h6V0H4v4zm10%200V0h-2v6h6V4h-4zm-2%2014h2v-4h4v-2h-6v6zM0%2014h4v4h2v-6H0v2z%22/%3E%3C/svg%3E"
                        : "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M0%200v6h2V2h4V0H0zm16%200h-4v2h4v4h2V0h-2zm0%2016h-4v2h6v-6h-2v4zM2%2012H0v6h6v-2H2v-4z%22/%3E%3C/svg%3E"
                    }
                  />
                </button>
                {dataToShow.filteredPolyLine.map((v) =>
                  !v.at(-1)?.latitude ? null : (
                    <AdvancedMarker
                      key={v[0].Employee_No}
                      onClick={() => handleOpen(v)}
                      position={
                        v[0]?.EndDatetime
                          ? {
                              lat: parseFloat(v[0]?.EndLatitude) || parseFloat(v.at(-1)?.latitude),
                              lng: parseFloat(v[0]?.EndLongitude) || parseFloat(v.at(-1)?.longitude),
                            }
                          : { lat: parseFloat(v.at(-1)?.latitude), lng: parseFloat(v.at(-1)?.longitude) }
                      }
                      svgIcon={`<svg width="52" height="58" viewBox="0 0 52 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="25.7373" cy="20.9843" r="20" fill="${getColor(v)}" />
                            <rect y="42" width="52" height="16" rx="8" fill="${getColor(v)}" />
                            <svg y="42" width="52" height="16" overflow="visible">
                            <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Verdana" font-size="${`${v[0]?.LeavingNo}`.length >= 8 ? 6 : 10}" fill="${getFontColor(v)}" font-weight="bold">${v[0]?.LeavingNo}</text>
                            </svg>
                            
                            ${
                              v[0]?.EndDatetime
                                ? v[0]?.PickupTime
                                  ? `<g transform="scale(1.75) translate(7, 4)">
                                      <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" fill="${getFontColor(v)}"/>
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.08296 7C2.50448 4.48749 4.48749 2.50448 7 2.08296V0H9V2.08296C11.5125 2.50448 13.4955 4.48749 13.917 7H16V9H13.917C13.4955 11.5125 11.5125 13.4955 9 13.917V16H7V13.917C4.48749 13.4955 2.50448 11.5125 2.08296 9H0V7H2.08296ZM4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z" fill="${getFontColor(v)}"/>
                                    </g>

                                    `
                                  : `<g clipPath="url(#clip0_${v[0].Employee_No})">
                                    <path d="M25.712 20.8278C28.3584 20.8278 30.5037 18.6825 30.5037 16.0362C30.5037 13.3898 28.3584 11.2445 25.712 11.2445C23.0657 11.2445 20.9203 13.3898 20.9203 16.0362C20.9203 18.6825 23.0657 20.8278 25.712 20.8278Z" fill="${getFontColor(v)}" />
                                    <path d="M25.712 37.9112C30.4294 37.9112 34.2537 34.0869 34.2537 29.3695C34.2537 24.6521 30.4294 20.8279 25.712 20.8279C20.9946 20.8279 17.1703 24.6521 17.1703 29.3695C17.1703 34.0869 20.9946 37.9112 25.712 37.9112Z" fill="${getFontColor(v)}" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_${v[0].Employee_No}">
                                      <rect width="18" height="20" fill="white" transform="translate(16.7373 10.9843)" />
                                    </clipPath>
                                  </defs>`
                                : otherWisePath(getFontColor(v)) +
                                  `
                                <circle cx="40" cy="8" r="8" fill="#fff" />
                                <svg x="40" y="8" width="8" height="8" overflow="visible">
                                  <text x="0" y="0" dominant-baseline="middle" text-anchor="middle" font-family="Verdana" font-size="9" fill="#000" font-weight="bold">${v[0]?.destination_count}</text>
                                </svg>`
                            }
                          </svg>`}
                    />
                  ),
                )}
              </GoogleMap>
            )}
            {!!currentSelected && modalVisible && (
              <div className="modal-container">
                <div aria-hidden="true" className="modal-back" onClick={handleClose}></div>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: {
                      xs: "90%",
                      sm: "80%",
                      md: "70%",
                      lg: "50%",
                      xl: "40%",
                    },
                    bgcolor: "background.paper",
                    borderRadius: 1,
                    boxShadow: 24,
                    p: 4,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 20,
                      [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20,
                    }}
                  >
                    <IconButton onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <Box
                    sx={{
                      position: "absolute",
                      top: 20,
                      [localizationStrings.getLanguage() === "ar" ? "right" : "left"]: 20,
                    }}
                  >
                    <Typography
                      id="modal-modal-description"
                      sx={{
                        textAlign: localizationStrings.getLanguage() === "ar" ? "right" : "left",
                        fontWeight: "700",
                        fontSize: 12,
                      }}
                    >
                      {localizationStrings.JourneyStarted}:{" "}
                      {moment(currentSelected.StartDatetime).utc().format("DD/MM/YYYY HH:mm")}
                      <br />
                      {localizationStrings.LastRecorded}:{" "}
                      {currentSelected.datetime
                        ? moment(currentSelected.datetime).utc().format("DD/MM/YYYY HH:mm")
                        : "Never Got location"}
                    </Typography>
                  </Box>
                  <Typography
                    id="modal-modal-description"
                    sx={{
                      mt: 5,
                      textAlign: "center",
                      fontWeight: "700",
                      fontSize: 18,
                    }}
                  >
                    {currentSelected.Full_Name}
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    sx={{
                      fontSize: 12,
                      textAlign: "center",
                      color: "#0000008A",
                    }}
                  >
                    {localizationStrings.EmployeeNo}: {currentSelected.Employee_No}
                    <br />
                    {localizationStrings.MobileNo}: {currentSelected.Mobile_No}
                  </Typography>
                  <div className="container-row-column">
                    <Box
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        marginTop: 1,
                      }}
                    >
                      {[
                        { body: localizationStrings.LeavingNo + ": " + currentSelected.LeavingNo },
                        {
                          body:
                            localizationStrings.LeavingTime +
                            ": " +
                            moment(currentSelected.LeavingDate).utc().format("DD/MM/YYYY HH:mm"),
                        },
                        {
                          body:
                            (localizationStrings.Company || "Company") +
                            ": " +
                            currentSelected.CompanyName +
                            " - " +
                            currentSelected.CompnyID,
                        },
                        {
                          body:
                            (localizationStrings.LocationNumber || "Location Number") +
                            ": " +
                            currentSelected.LocationNo,
                        },
                        { body: localizationStrings.HajjCount + ": " + currentSelected.hajj_count },
                        {
                          body:
                            localizationStrings.RemainingToDestination +
                            ": " +
                            (() => {
                              const pi =
                                dataToShow.filteredPolyLine
                                  .find((v) => v[0].Employee_No === currentSelected.Employee_No)
                                  ?.at(-1) || {};
                              var lat1 = currentSelected.Latitude;
                              var lon1 = currentSelected.Longitude;
                              var lat2 = pi.EndDatetime ? pi.EndLatitude || pi.latitude : pi.latitude;
                              var lon2 = pi.EndDatetime ? pi.EndLongitude || pi.longitude : pi.longitude;
                              return Math.round(getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) * 100) / 100 + " km";
                            })(),
                        },
                      ].map((v) => (
                        <Typography
                          id="modal-modal-description"
                          sx={{
                            fontSize: 14,
                            textAlign:
                              localizationStrings.getLanguage() === "ar"
                                ? { xs: "center", sm: "right" }
                                : { xs: "center", sm: "left" },
                          }}
                        >
                          {v.body}
                        </Typography>
                      ))}
                    </Box>
                    <Box
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {[
                        { body: localizationStrings.BusNumber + ": " + currentSelected.BusNo },
                        { body: localizationStrings.BusPlateNo + ": " + currentSelected.BusPlant },
                        { body: localizationStrings.DriverName + ": " + currentSelected.Driver_Name },
                        { body: localizationStrings.DriverMobileNumber + ": " + currentSelected.Driver_Mobile },
                        {
                          body:
                            localizationStrings.DestinationCount +
                            ": " +
                            currentSelected.currentDestination +
                            " / " +
                            currentSelected.destination_count,
                        },
                        { body: localizationStrings.manifestId + ": " + currentSelected.manifestId },
                        {
                          body:
                            localizationStrings.manifestType +
                            ": " +
                            (currentSelected.manifestType == 1
                              ? localizationStrings.DepartureManifest
                              : localizationStrings.ArrivalManifest),
                        },
                      ].map((v) => (
                        <Typography
                          id="modal-modal-description"
                          sx={{
                            fontSize: 14,
                            textAlign:
                              localizationStrings.getLanguage() === "ar"
                                ? { xs: "center", sm: "left" }
                                : { xs: "center", sm: "right" },
                          }}
                        >
                          {v.body}
                        </Typography>
                      ))}
                    </Box>
                  </div>

                  {/* <Typography
                    id="modal-modal-description"
                    sx={{
                      fontSize: 14,
                      textAlign:
                        localizationStrings.getLanguage() === "ar"
                          ? { xs: "center", sm: "right" }
                          : { xs: "center", sm: "left" },
                    }}
                  >
                    {localizationStrings.HajjCompany}: {currentSelected.Est_Name}
                  </Typography> */}
                  {[
                    // { body: localizationStrings.HajjCompany + ": " + currentSelected.Est_Name },
                    {
                      body:
                        localizationStrings.PathName +
                        ": " +
                        currentSelected.pathName +
                        " (" +
                        currentSelected.pathId +
                        ")",
                    },

                    { body: localizationStrings.HEBName + ": " + currentSelected.HEB_Name },
                    { body: localizationStrings.Destination + ": " + currentSelected.HouseName },
                    {
                      comp: (
                        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: 2 }}>
                          <Typography
                            id="modal-modal-description"
                            sx={{
                              fontSize: 14,
                              gap: 2,
                              textAlign:
                                localizationStrings.getLanguage() === "ar"
                                  ? { xs: "center", sm: "right" }
                                  : { xs: "center", sm: "left" },
                            }}
                          >
                            {localizationStrings.DestinationLatLong}:{" "}
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`https://maps.google.com/?q=${currentSelected.Latitude},${currentSelected.Longitude}`}
                              style={{ fontSize: 10 }}
                            >
                              {currentSelected.Latitude}, {currentSelected.Longitude}
                            </a>
                          </Typography>
                          <ChangeDestDialog
                            leavingNo={currentSelected.LeavingNo}
                            houseId={currentSelected.hid}
                            currentLocation={{
                              latitude: currentSelected.Latitude,
                              longitude: currentSelected.Longitude,
                            }}
                            refresh={getTracking}
                            key={currentSelected.id}
                          />
                        </Box>
                      ),
                    },
                    {
                      body: (
                        <>
                          {localizationStrings.CurrentLatLong}:{" "}
                          {(() => {
                            const pi =
                              dataToShow.filteredPolyLine
                                .find((v) => v[0].Employee_No === currentSelected.Employee_No)
                                ?.at(-1) || {};
                            return (
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`https://maps.google.com/?q=${
                                  pi.EndDatetime
                                    ? (pi.EndLatitude || pi.latitude) + "," + (pi.EndLongitude || pi.longitude)
                                    : pi.latitude + "," + pi.longitude
                                }`}
                              >
                                {pi.EndDatetime
                                  ? (pi.EndLatitude || pi.latitude) + ", " + (pi.EndLongitude || pi.longitude)
                                  : pi.latitude + ", " + pi.longitude}
                              </a>
                            );
                          })()}
                        </>
                      ),
                    },
                  ].map((v) =>
                    v.comp ? (
                      v.comp
                    ) : (
                      <Typography
                        id="modal-modal-description"
                        sx={{
                          fontSize: 14,
                          textAlign:
                            localizationStrings.getLanguage() === "ar"
                              ? { xs: "center", sm: "right" }
                              : { xs: "center", sm: "left" },
                        }}
                      >
                        {v.body}
                      </Typography>
                    ),
                  )}

                  <div style={{ height: 20 }} />

                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{localizationStrings.Destination}</TableCell>
                          <TableCell>{localizationStrings.HajjCompany}</TableCell>
                          <TableCell>{localizationStrings.HajjCount}</TableCell>
                          <TableCell>{localizationStrings.Updatelocation}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentSelected.destinations.map((v, i) => (
                          <TableRow key={i}>
                            <TableCell>
                              {v.name}
                              <br />(
                              {v.ended_at
                                ? moment(v.ended_at).utc().format("DD/MM/YYYY HH:mm")
                                : localizationStrings.NotEnded}
                              )
                            </TableCell>
                            <TableCell>{v.Est_Name}</TableCell>
                            <TableCell>{v.hajj_count}</TableCell>
                            <TableCell>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`https://maps.google.com/?q=${v.lat},${v.lng}`}
                              >
                                {v.lat}, {v.lng}
                              </a>{" "}
                              <ChangeDestDialog
                                leavingNo={currentSelected.LeavingNo}
                                houseId={v.hid}
                                currentLocation={{
                                  latitude: v.lat,
                                  longitude: v.lng,
                                }}
                                refresh={getTracking}
                                key={v.hid}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                        {/* <TableRow>
                          <TableCell>asd</TableCell>
                          <TableCell>asdf</TableCell>
                        </TableRow> */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* {currentSelected.destinations.map((v, i) => (
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-end", gap: 2, mb: 2 }}>
                      <Box sx={{}}>
                        <Typography
                          id="modal-modal-description"
                          sx={{
                            fontSize: 14,
                            gap: 2,
                            textAlign:
                              localizationStrings.getLanguage() === "ar"
                                ? { xs: "center", sm: "right" }
                                : { xs: "center", sm: "left" },
                          }}
                        >
                          {localizationStrings.Destination} {i + 1}: {v.name}
                        </Typography>
                        <Typography
                          id="modal-modal-description"
                          sx={{
                            fontSize: 10,
                            gap: 2,
                            textAlign:
                              localizationStrings.getLanguage() === "ar"
                                ? { xs: "center", sm: "right" }
                                : { xs: "center", sm: "left" },
                          }}
                        >
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://maps.google.com/?q=${v.lat},${v.lng}`}
                          >
                            {v.lat}, {v.lng}
                          </a>{" "}
                          (
                          {v.ended_at
                            ? moment(v.ended_at).utc().format("DD/MM/YYYY HH:mm")
                            : localizationStrings.NotEnded}
                          )
                        </Typography>
                      </Box>
                      <ChangeDestDialog
                        leavingNo={currentSelected.LeavingNo}
                        houseId={v.hid}
                        currentLocation={{
                          latitude: v.lat,
                          longitude: v.lng,
                        }}
                        refresh={getTracking}
                        key={v.hid}
                      />
                    </Box>
                  ))} */}

                  {checkRoleExists(6) && (
                    <Box
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => {
                          handleOpenConfirmDialog(currentSelected);
                          // const shouldCountinue = prompt();
                          // if (shouldCountinue) {
                          //   finishTripButton(currentSelected);
                          // }
                        }}
                      >
                        {!currentSelected.EndDatetime
                          ? localizationStrings.EndThisTrip
                          : !currentSelected.PickupTime
                            ? localizationStrings.FinishPickup
                            : !currentSelected.AssemblyPointTime
                              ? localizationStrings.FinishAssemblyPoint
                              : localizationStrings.SomethingWrongError}
                      </Button>
                    </Box>
                  )}
                  <Box
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      marginTop: 20,
                    }}
                  >
                    <Button variant="contained" onClick={() => chat(currentSelected)}>
                      {localizationStrings.ChatWithThisGuidance}
                    </Button>
                  </Box>
                </Box>
              </div>
            )}
            {!!currentSelected && modalVisible1 && (
              <div className="modal-container">
                <div aria-hidden="true" className="modal-back" onClick={handleClose1}></div>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: {
                      xs: "90%",
                      sm: "70%",
                      md: "60%",
                      lg: "40%",
                      xl: "30%",
                    },
                    bgcolor: "background.paper",
                    borderRadius: 1,
                    boxShadow: 24,
                    p: 4,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 20,
                      [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20,
                    }}
                  >
                    <IconButton onClick={handleClose1}>
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  <Typography
                    id="modal-modal-description"
                    sx={{
                      mt: 3,
                      textAlign: "center",
                      fontWeight: "700",
                      fontSize: 18,
                    }}
                  >
                    {currentSelected.Full_Name} {localizationStrings.NeedsHelp}
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    sx={{
                      fontSize: 12,
                      textAlign: "center",
                      color: "#0000008A",
                    }}
                  >
                    {localizationStrings.EmployeeNo}: {currentSelected.Employee_No}
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    sx={{
                      fontSize: 12,
                      textAlign: "center",
                      color: "#0000008A",
                    }}
                  >
                    {localizationStrings.MobileNo}: {currentSelected.Mobile_No}
                  </Typography>

                  <a class="button1" onClick={() => pressResolve()}>
                    {localizationStrings.ResolveIssue}
                  </a>
                </Box>
              </div>
            )}
            <Dialog open={openConfirmDialog} onClose={() => handleCloseConfirmDialog(false)}>
              {/* <DialogTitle sx={{ color: 'black' }}>{localizationStrings.AreYouSureCloseTrip}</DialogTitle> */}
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {localizationStrings.AreYouSureCloseTrip}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button sx={{ color: "black" }} onClick={() => handleCloseConfirmDialog(false)}>
                  {localizationStrings.No}
                </Button>
                <Button sx={{ color: "black" }} onClick={() => handleCloseConfirmDialog(true)} autoFocus>
                  {localizationStrings.Yes}
                </Button>
              </DialogActions>
            </Dialog>
            <Chat
              guidanceId={currentSelectedGuidanceId}
              title={currentSelectedChatTitle}
              visible={chatVisible}
              handleClose={() => {
                setChatVisible(false);
                setCurrentSelectedGuidanceId(null);
              }}
            />
          </div>
        )}
      </FullScreen>
      <Drawer
        anchor={localizationStrings.getLanguage() === "ar" ? "left" : "right"}
        open={filterShown}
        onClose={() => setFilterShown(false)}
        dir={localizationStrings.getLanguage() === "ar" ? "rtl" : "ltr"}
      >
        <Box sx={{ width: { xl: "900px", md: "600px", sm: "300px" }, padding: 2 }}>
          <Typography
            sx={{
              fontSize: 30,
              fontWeight: "700",
              textAlign: localizationStrings.getLanguage() === "ar" ? "right" : "left",
            }}
            gutterBottom
          >
            {localizationStrings.Filters}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: 20,
            [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20,
          }}
        >
          <IconButton onClick={() => setFilterShown(false)}>
            <CloseIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
        <Divider />
        {Object.keys(filters).map((key) => {
          const filter = filters[key];
          return (
            <Box
              key={key}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 2,
                borderBottom: "1px solid #ccc",
                width: { xl: "900px", md: "600px", sm: "300px" },
              }}
            >
              {filter.type == "select" ? (
                <FormControl fullWidth variant="filled">
                  <InputLabel id={`${key}-label`}>{filter.title}</InputLabel>
                  <Select
                    labelId={`${key}-label`}
                    value={selectedFilters[key]}
                    label={filter.title}
                    onChange={(e) => setSelectedFilters((prev) => ({ ...prev, [key]: e.target.value }))}
                  >
                    {filter.options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : filter.type == "radio" ? (
                <Box sx={{}}>
                  <Typography sx={{ fontSize: 20, fontWeight: "600" }}>{filter.title}</Typography>
                  <RadioGroup
                    value={selectedFilters[key]}
                    onChange={(e) => setSelectedFilters((prev) => ({ ...prev, [key]: e.target.value }))}
                    sx={{ marginLeft: 2, display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 2 }}
                  >
                    {filter.options.map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>
                </Box>
              ) : filter.type == "checkbox" ? (
                <Box sx={{}}>
                  <Typography sx={{ fontSize: 20, fontWeight: "600" }}>{filter.title}</Typography>
                  <FormGroup sx={{ marginLeft: 2, display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 2 }}>
                    {filter.options.map((option) => (
                      <FormControlLabel
                        key={option.value}
                        control={
                          <Checkbox
                            checked={selectedFilters[key]?.includes(option.value) || false}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedFilters((prev) => ({
                                  ...prev,
                                  [key]: [...(prev[key] || []), option.value],
                                }));
                              } else {
                                setSelectedFilters((prev) => ({
                                  ...prev,
                                  [key]: prev[key].filter((v) => v !== option.value),
                                }));
                              }
                            }}
                          />
                        }
                        label={option.label}
                      />
                    ))}
                  </FormGroup>
                </Box>
              ) : filter.type == "by_est" ? (
                <Box sx={{ width: "95%" }}>
                  <Typography sx={{ fontSize: 20, fontWeight: "600", marginBottom: 2 }}>
                    {localizationStrings.Company}
                  </Typography>
                  <FormControl fullWidth variant="filled" sx={{ mx: 2 }}>
                    <InputLabel id="demo-simple-select-label">{localizationStrings.Company}</InputLabel>
                    <Select
                      labelId="demo-multiple-chip-label"
                      id="demo-multiple-chip"
                      multiple
                      value={selectedFilters[key] || []}
                      onChange={(e) =>
                        setSelectedFilters((prev) => ({
                          ...prev,
                          [key]:
                            typeof e.target.value == "string"
                              ? e.target.value.split(",").map(parseInt)
                              : e.target.value,
                        }))
                      }
                      input={<FilledInput id="select-multiple-chip" label="Chip" />}
                      endAdornment={
                        selectedFilters[key] && selectedFilters[key].length > 0 ? (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="clear all"
                              onClick={() => setSelectedFilters((prev) => ({ ...prev, [key]: [] }))}
                              edge="end"
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null
                      }
                      renderValue={(selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selected.map((value) => {
                            return <Chip key={value} label={value} />;
                          })}
                        </Box>
                      )}
                    >
                      {allEst.map((val) => (
                        <MenuItem key={val.Est_ID} value={val.Est_ID} title={val.Est_Name}>
                          <Checkbox checked={(selectedFilters[key] || []).indexOf(val.Est_ID) > -1} />
                          <ListItemText
                            primaryTypographyProps={{
                              fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
                            }}
                            primary={`(${val.Est_ID}) ${val.Est_Name} Total: ${val.count}`}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              ) : null}
            </Box>
          );
        })}
      </Drawer>
    </div>
  );
}
export default Tracking;

function getColor(data) {
  // // var colorArray = ['#FF0000', '#0000FF', '#FFFF00', '#FF00FF'];
  // var x = Math.floor((random(seed) / 10000) * (256 - 100));
  // var y = Math.floor((random(seed + 5) / 10000) * (256 - 100));
  // var z = Math.floor((random(seed + 10) / 10000) * (256 - 100));
  // var color = 'rgb(' + x + ',' + y + ',' + z + ')';
  // function random(seed) {
  //   var x = Math.sin(seed) * 10000;
  //   return Math.abs(x);
  // }

  // // console.log(random());

  // // let color = Math.floor(Math.abs(Math.sin(seed) * 16777215));
  // // color = color.toString(16);

  // // return '#' + color.padStart(6, '0');
  // // const i = Math.floor(Math.abs(random()) % colorArray.length);
  // // return colorArray[i];
  // return color;
  const pickupColor = !data[0].EndDatetime ? "#000" : getBackgroundColor(Math.abs(data[0].pickupTime));
  const busColor = data[0].EndDatetime ? "#000" : getBackgroundColor(Math.abs(data[0].bussTime));
  const assemblyPointColor = !data[0].PickupTime ? "#000" : getBackgroundColor(Math.abs(data[0].assemblyPointTime));
  const color = data[0].PickupTime ? assemblyPointColor : data[0].EndDatetime ? pickupColor : busColor;
  return color;
}
function getFontColor(data) {
  // var x = Math.floor((random(seed) / 10000) * (256 - 100));
  // var y = Math.floor((random(seed + 5) / 10000) * (256 - 100));
  // var z = Math.floor((random(seed + 10) / 10000) * (256 - 100));
  // var color = 'rgb(' + x + ',' + y + ',' + z + ')';
  // function random(seed) {
  //   var x = Math.sin(seed) * 10000;
  //   return Math.abs(x);
  // }

  // // console.log(random());

  // // let color = Math.floor(Math.abs(Math.sin(seed) * 16777215));
  // // color = color.toString(16);

  // // return '#' + color.padStart(6, '0');
  // // const i = Math.floor(Math.abs(random()) % colorArray.length);
  // // return colorArray[i];
  // return color;
  const pickupColor = !data[0].EndDatetime
    ? "#fff"
    : Math.abs(data[0].pickupTime) < 60
      ? "#fff"
      : Math.abs(data[0].pickupTime) >= 60 && Math.abs(data[0].pickupTime) < 120
        ? "#fff"
        : "#fff";
  const busColor = data[0].EndDatetime
    ? "#fff"
    : Math.abs(data[0].bussTime) < 60
      ? "#fff"
      : Math.abs(data[0].bussTime) >= 60 && Math.abs(data[0].bussTime) < 120
        ? "#fff"
        : "#fff";
  const color = data[0].EndDatetime ? pickupColor : busColor;
  return color;
}

function EmployeeItem({
  handleOpen,
  handleOpen1,
  formatTime,
  StartDatetime,
  EndDatetime,
  Full_Name,
  Employee_No,
  LeavingNo,
  PickupTime,
  bussTime,
  pickupTime,
  assemblyPointTime,
  allData,
  NeedHelp,
  unreadCount,
  chat,
  ...v
}) {
  // const  = useMemo(
  //   () => ,
  //   [EndDatetime, StartDatetime]
  // );
  // const  = useMemo(
  //   () => ,
  //   [EndDatetime, PickupTime]
  // );
  const pickupColor = !EndDatetime || PickupTime ? "#000" : getBackgroundColor(Math.abs(pickupTime));

  const sb = (size) => <div style={{ width: size, height: size }} />;
  let offlineFor = Math.abs(moment(v.datetime).add(new Date().getTimezoneOffset(), "minute").diff(moment(), "minute"));
  let unableToGet = false;
  if (offlineFor > 5 && offlineFor > Math.abs(bussTime) + Math.abs(pickupTime) + Math.abs(assemblyPointTime)) {
    offlineFor = 0;
    v.datetime = null;
    unableToGet = true;
  }
  return (
    <React.Fragment>
      <ListItem
        button
        onClick={(e) => {
          if (e.defaultPrevented) return;
          handleOpen(allData);
        }}
      >
        <ListItemText
          style={{
            textAlign: localizationStrings.getLanguage() === "ar" ? "right" : "left",
          }}
        >
          <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center" }}>
            <Typography sx={{ fontSize: 12, fontWeight: "700", flex: 1 }}>
              {Full_Name} - {Employee_No}
              <br />
              <span style={{ fontWeight: "400" }}>
                {localizationStrings.LeavingNo}: {LeavingNo}
              </span>
              {!EndDatetime && <br />}
              {!EndDatetime && (
                <span style={{ fontWeight: "400" }}>
                  {localizationStrings.DestinationCount}: {v.currentDestination} / {v.destination_count}
                </span>
              )}
              <br />
            </Typography>
            {NeedHelp == 1 && (
              <div
                onClick={(e) => {
                  e.preventDefault?.();
                  handleOpen1(allData);
                }}
              >
                <Typography sx={{ fontSize: 20, fontWeight: "700", color: "white" }}>
                  <Box style={{ alignItems: "center", justifyContent: "center" }}>
                    <Box
                      sx={{
                        backgroundColor: "red",
                        borderRadius: 100,
                        height: 30,
                        width: 30,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box style={{ textAlign: "center", verticalAlign: "center" }}>?</Box>
                    </Box>
                  </Box>
                </Typography>
              </div>
            )}
          </Box>
          {sb(7)}
          <Typography sx={{ fontSize: 12, fontWeight: "700" }}>
            <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.51221 0.13218C3.09981 0.30138 2.78261 0.6292 2.67151 1.0046C2.60281 1.232 2.58691 1.5651 2.58691 2.7071V4.1241H1.92601C1.13821 4.1241 0.979613 4.177 0.900313 4.4837C0.868513 4.5894 0.842114 4.7533 0.842114 4.8485C0.842114 4.9913 0.820914 5.0177 0.672914 5.0494C0.392714 5.1129 0.223514 5.2186 0.101914 5.4195C-0.00388646 5.5887 -0.00918699 5.6575 0.00671301 6.4241L0.0226136 7.2437L0.223514 7.4393L0.419113 7.6402L0.990113 7.6561C1.66161 7.6772 1.88901 7.6085 2.05821 7.3389C2.15861 7.1802 2.16391 7.0956 2.15341 6.3078L2.13751 5.4513L1.98421 5.2926C1.89961 5.208 1.75681 5.1182 1.66691 5.1023C1.33381 5.0336 1.31801 5.023 1.31801 4.8379C1.31801 4.5894 1.42371 4.5471 2.05291 4.5471H2.58691V11.7115C2.58691 16.6975 2.60281 18.9552 2.64511 19.1508C2.75081 19.6743 3.03111 20.1607 3.40651 20.4991L3.75011 20.8057V21.4138C3.75011 22.1329 3.80301 22.3549 4.03041 22.614C4.32651 22.9524 4.50091 23 5.52141 23C6.54191 23 6.71631 22.9524 7.01241 22.614C7.22921 22.3655 7.29271 22.1329 7.29271 21.5777V21.1336L10.7929 21.1653C12.7175 21.1864 14.8324 21.2023 15.4986 21.2023H16.7042V21.6729C16.7042 22.0853 16.72 22.1752 16.8522 22.4237C16.9685 22.651 17.0531 22.7356 17.2805 22.852C17.5554 22.9947 17.5766 23 18.4754 23C19.3743 23 19.3954 22.9947 19.6704 22.852C19.8977 22.7356 19.9823 22.651 20.0986 22.4237C20.2414 22.154 20.2467 22.1064 20.2467 21.4032V20.663L20.4952 20.388C20.6274 20.24 20.823 19.9386 20.9288 19.7218L21.1191 19.3253L21.1455 16.9195L21.172 14.5138L22.0232 14.4874C22.6313 14.4662 22.9009 14.4398 22.9591 14.3869C23.0596 14.3076 23.1547 14.0062 23.1547 13.7683C23.1547 13.6149 23.1706 13.5991 23.3557 13.5674C23.472 13.5515 23.6253 13.488 23.7046 13.4246C23.9849 13.2078 24.0007 13.1074 24.0007 11.8595C24.0007 10.5906 23.9849 10.5271 23.6518 10.3051C23.4244 10.157 22.4092 10.157 22.166 10.3103C21.8541 10.5007 21.8329 10.5959 21.8329 11.9283V13.1232L22.0338 13.3294C22.1819 13.4722 22.3035 13.5409 22.4568 13.5674C22.663 13.5991 22.6789 13.6149 22.6789 13.7683C22.6789 14.0432 22.6154 14.0644 21.8805 14.0644C21.32 14.0644 21.2037 14.0485 21.1773 13.9798C21.1614 13.9322 21.1455 11.0136 21.1455 7.4922V1.0839L21.0187 0.81425C20.8706 0.49172 20.6009 0.25908 20.2097 0.11103C19.9189 -3.72529e-07 19.9189 0 11.8768 0H3.82951L3.51221 0.13218ZM15.4246 1.0363C15.5357 1.1103 15.5409 1.1368 15.5409 1.951C15.5409 2.6807 15.5304 2.797 15.4511 2.871C15.3665 2.9398 14.9435 2.9556 11.8768 2.9715L8.39241 2.9874L8.29201 2.8605C8.20211 2.7547 8.19151 2.649 8.19151 1.9828C8.19151 1.5651 8.20741 1.1844 8.22321 1.1368C8.31841 0.89885 8.38721 0.89356 11.9455 0.93057C14.7214 0.95701 15.3242 0.97287 15.4246 1.0363ZM19.6122 4.0184C19.718 4.1241 19.718 4.1929 19.718 9.5331C19.718 14.1225 19.7074 14.9579 19.6439 15.0478C19.5699 15.1483 19.4219 15.1483 11.9297 15.1641L4.28951 15.1747L4.17841 15.0372C4.06741 14.8945 4.06741 14.8839 4.06741 9.5437C4.06741 4.2087 4.06741 4.1929 4.17841 4.0501L4.28421 3.9126H11.898C19.4377 3.9126 19.5065 3.9126 19.6122 4.0184ZM5.08261 17.9241C5.22531 18.0722 5.24121 18.1145 5.21471 18.3101C5.17771 18.5745 4.98211 18.7701 4.74951 18.7701C4.34231 18.7701 4.09381 18.4264 4.24721 18.0669C4.33701 17.8395 4.45341 17.7708 4.71771 17.7655C4.87631 17.7655 4.95571 17.8025 5.08261 17.9241ZM6.57891 17.8977C6.67931 17.9929 6.71111 18.0828 6.71111 18.2625C6.71111 18.4582 6.68461 18.5163 6.54721 18.6326C6.31981 18.823 6.06601 18.8177 5.85981 18.6168C5.65891 18.4106 5.64831 18.1092 5.83861 17.903C6.01841 17.7126 6.39381 17.7074 6.57891 17.8977ZM18.0895 17.8237C18.1476 17.8554 18.2269 17.9611 18.2692 18.0669C18.412 18.4053 18.1793 18.7701 17.8145 18.7701C17.3492 18.7701 17.1219 18.1515 17.4814 17.8713C17.6295 17.7549 17.9203 17.7338 18.0895 17.8237ZM19.6704 17.9189C19.866 18.1198 19.8766 18.3841 19.6968 18.5956C19.5911 18.7172  19.5276 18.7437 19.3214 18.7437C19.1152 18.7437 19.0518 18.7172 18.946 18.5956C18.8085 18.4317 18.7768 18.1145 18.8878 17.9717C19.0835 17.7179 19.443 17.6968 19.6704 17.9189Z"
                    fill={EndDatetime ? "#000" : getBackgroundColor(Math.abs(bussTime))}
                  />
                </svg>
                {sb(10)}
                <span
                  style={{
                    color: EndDatetime ? "#000" : getBackgroundColor(Math.abs(bussTime)),
                  }}
                >
                  {formatTime(bussTime)}
                </span>
              </Box>
              <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center", flex: 1 }}>
                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_103_19)">
                    <path
                      d="M8.97465 9.84356C11.621 9.84356 13.7663 7.69825 13.7663 5.05189C13.7663 2.40553 11.621 0.260223 8.97465 0.260223C6.32829 0.260223 4.18298 2.40553 4.18298 5.05189C4.18298 7.69825 6.32829 9.84356 8.97465 9.84356Z"
                      fill={pickupColor}
                    />
                    <path
                      d="M8.97465 26.9269C13.6921 26.9269 17.5163 23.1027 17.5163 18.3852C17.5163 13.6678 13.6921 9.84357 8.97465 9.84357C4.25722 9.84357 0.432983 13.6678 0.432983 18.3852C0.432983 23.1027 4.25722 26.9269 8.97465 26.9269Z"
                      fill={pickupColor}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_103_19">
                      <rect width="18" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {sb(10)}
                <span style={{ color: pickupColor }}>{formatTime(pickupTime)}</span>
              </Box>
              <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center", flex: 1 }}>
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                    fill={!PickupTime ? "#000" : getBackgroundColor(Math.abs(assemblyPointTime))}
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2.08296 7C2.50448 4.48749 4.48749 2.50448 7 2.08296V0H9V2.08296C11.5125 2.50448 13.4955 4.48749 13.917 7H16V9H13.917C13.4955 11.5125 11.5125 13.4955 9 13.917V16H7V13.917C4.48749 13.4955 2.50448 11.5125 2.08296 9H0V7H2.08296ZM4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z"
                    fill={!PickupTime ? "#000" : getBackgroundColor(Math.abs(assemblyPointTime))}
                  />
                </svg>
                {sb(10)}
                <span
                  style={{
                    color: !PickupTime ? "#000" : getBackgroundColor(Math.abs(assemblyPointTime)),
                  }}
                >
                  {formatTime(assemblyPointTime)}
                </span>
              </Box>
              <Box
                sx={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  opacity: unreadCount > 0 ? 1 : 0,
                }}
              >
                <IconButton
                  type="submit"
                  onClick={(e) => {
                    if (unreadCount <= 0) return;
                    if (e.defaultPrevented) return;
                    e.preventDefault();
                    chat(allData[0]);
                  }}
                >
                  <Badge badgeContent={unreadCount} color="secondary">
                    <ChatIcon />
                  </Badge>
                </IconButton>
              </Box>
            </Box>
          </Typography>
          {offlineFor > 5 && !EndDatetime && (
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: "700",
                color: "white",
                marginTop: "10px",
              }}
            >
              <Box style={{ alignItems: "center", justifyContent: "center" }}>
                <Box
                  sx={{
                    backgroundColor: "red",
                    borderRadius: 100,
                    height: 14 * 1.5,
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "5px",
                    paddingLeft: "5px",
                  }}
                >
                  <Box style={{ textAlign: "center", verticalAlign: "center" }}>
                    {/* Offline for {offlineFor} minutes */}
                    {localizationStrings.getLanguage() == "en"
                      ? localizationStrings.offlineForXMinutes.replace("x", offlineFor)
                      : localizationStrings.offlineForXMinutes.replace("x", offlineFor).EntoAr()}
                  </Box>
                </Box>
              </Box>
            </Typography>
          )}
          {(!allData[0].datetime || unableToGet) && (
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: "700",
                color: "white",
                marginTop: "10px",
              }}
            >
              <Box style={{ alignItems: "center", justifyContent: "center" }}>
                <Box
                  sx={{
                    backgroundColor: "red",
                    borderRadius: 100,
                    height: 14 * 1.5,
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "5px",
                    paddingLeft: "5px",
                  }}
                >
                  <Box style={{ textAlign: "center", verticalAlign: "center" }}>
                    {localizationStrings.UnableToGetLocation}
                  </Box>
                </Box>
              </Box>
            </Typography>
          )}
        </ListItemText>
      </ListItem>
      <Divider />
    </React.Fragment>
  );
}
